import { createAsyncThunk } from "@reduxjs/toolkit";
import { postObjectsSearch } from "domain/objects/api/post-objects-search";
import { ObjectsSearchRequestDto } from "domain/objects/entities/dtos/objects-search-reques.dto";

const getObjectsSearchAction = createAsyncThunk(
  "objects/v2/getObjectsSearch",
  async (payload: ObjectsSearchRequestDto) => {
    return await postObjectsSearch(payload);
  }
);

export default getObjectsSearchAction;
